import React from 'react';
import { Form } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setTypeFilter, resetTypeFilter } from '../../../actions/filters';
import { ARRANGEMENT_TYPE_SLUG, SHOP_TYPES, EDUCATION_TYPE_SLUG, LESSON_TYPE_SLUG } from '../../../../config';

class TypeFilter extends React.Component {
  state = {
    filter: this.props.typeFilter,
  };

  componentWillUnmount() {
    this.props.resetTypeFilter();
  }

  handleFilterChange = (event) => {
    let filter = event.currentTarget.value;
    this.setState({ filter });
    this.props.setTypeFilter(filter);
  };

  render() {
    return <Form.Group controlId="filter.type">
      <Form.Label>{ gettext('Категория товара') }</Form.Label>
      <Form.Control as='select' size='sm' value={ this.state.filter } onChange={ this.handleFilterChange }>
        <option value={''}>{ gettext('Все') }</option>
        <option value={ ARRANGEMENT_TYPE_SLUG }>{ SHOP_TYPES[ARRANGEMENT_TYPE_SLUG]['title'] }</option>
        <option value={ LESSON_TYPE_SLUG }>{ SHOP_TYPES[LESSON_TYPE_SLUG]['title'] }</option>
        {this.props.showEducation && <option value={ EDUCATION_TYPE_SLUG }>{ SHOP_TYPES[EDUCATION_TYPE_SLUG]['title'] }</option> }
      </Form.Control>
    </Form.Group>
  }
}

let mapStateToProps = (state) => {
  return {
    typeFilter: state.filters.typeFilter,
  }
};

export default compose(connect(mapStateToProps, {setTypeFilter, resetTypeFilter}))(TypeFilter)
